import { _ } from "../../../core/polyglot/polyglot.js";
import {
	formatFullNoDecimals,
	formatFullWithTwoDecimals,
	formatThousandNoDecimals,
} from "../../../core/helpers/currency-formatting-util.js";
import { nonEmptyValueOrDefault } from "../../../core/helpers/object-util.js";
import ClosingBalanceFormulaNode from "../../keyFigure/formula/ClosingBalanceFormulaNode.js";
import keyFigureValueFormatter from "../../keyFigure/rendering/keyFigureValueFormatter.js";

export const valueLabel = "value";

export const nameLabel = "name";

export const nameAndValueLabel = "name-and-value";

export const displayLabels = {
	[valueLabel]: _("Value"),
	[nameAndValueLabel]: _("Name & Value"),
	[nameLabel]: _("Name"),
};

export const precisionsLabels = {
	default: _("Default"),
	decimals: _("Show decimals"),
	"smart-shortening": _("Smart shortening"),
	"shorten-thousands": _("Shorten thousands"),
};

export const precisionFormatters = {
	default: formatFullNoDecimals,
	decimals: formatFullWithTwoDecimals,
	"shorten-thousands": formatThousandNoDecimals,
	"smart-shortening": () => {
		throw new Error(
			"This is a special case that should be handled by hand",
		);
	},
};

export const defaultAccountOperation = "period";

const accountOperations = {
	[defaultAccountOperation]: (expression) => expression,
	closing: (expression) => new ClosingBalanceFormulaNode({ expression }),
};

export const accountOperationsLabels = {
	[defaultAccountOperation]: _("Period"),
	closing: _("Closing Balance"),
};

/**
 * Todo: Add JSDoc comment
 */
export function makeAccountOperation({ type, expression }) {
	const builder =
		accountOperations[type] ?? accountOperations[defaultAccountOperation];
	return builder(expression);
}

/**
 * Todo: Add JSDoc comment
 */
export function getFormattedValue({ value, precision }) {
	return nonEmptyValueOrDefault({
		value: getRawFormattedValue({ value, precision }),
	});
}

function getRawFormattedValue({ value, precision }) {
	const formattingFn = precisionFormatters[precision];
	const valueType = value.getValueType();

	if (
		precision === "smart-shortening" ||
		valueType !== "Amount" ||
		!formattingFn
	) {
		return keyFigureValueFormatter.format(value);
	}
	return formattingFn(value.getValue());
}
